import request from '../utils/request'

// 查询设置是否自定义
export function getUserConfigValue (query) {
    return request({
      url: 'system/userConfig/getUserConfigValue',
      method: 'get',
      params: query
    })
  }

//   保存自定义
export function saveUserConfig (data) {
    return request({
      url: 'system/userConfig/addOrUpdate',
      method: 'post',
      data
    })
}

// 验证密码
export function validPassword (data) {
    return request({
      url: 'system/canteen/config/validScalePassword',   
        method: 'post',
        data
    })
}